import { lumi } from '@/lib/lumi'

export type SubmissionStatus = 'submitted' | 'graded'

export interface AssignmentSubmission {
  _id: string
  assignmentId: string
  courseId: string
  courseSlug: string
  moduleId: string
  userId: string
  studentName: string
  studentEmail?: string
  note?: string
  fileUrl?: string
  fileName?: string
  status: SubmissionStatus
  score?: number
  feedback?: string
  creator?: string
  createdAt: string
  updatedAt: string
}

function nowIso() {
  return new Date().toISOString()
}

export function submissionLabel(status: SubmissionStatus | undefined) {
  if (status === 'graded') return 'Calificado'
  if (status === 'submitted') return 'Entregado'
  return 'Sin entrega'
}

export async function fetchCourseSubmissions(courseId: string) {
  const { list } = await lumi.entities.assignment_submissions.list({
    filter: { courseId },
    sort: { createdAt: -1 },
    limit: 400,
  })
  return (list ?? []) as AssignmentSubmission[]
}

export async function fetchAllSubmissions() {
  const { list } = await lumi.entities.assignment_submissions.list({
    sort: { createdAt: -1 },
    limit: 800,
  })
  return (list ?? []) as AssignmentSubmission[]
}

export async function createSubmission(payload: {
  assignmentId: string
  courseId: string
  courseSlug: string
  moduleId: string
  userId: string
  studentName: string
  studentEmail: string
  note: string
  fileUrl: string
  fileName: string
  score?: number
}) {
  const stamp = nowIso()
  return (await lumi.entities.assignment_submissions.create({
    assignmentId: payload.assignmentId,
    courseId: payload.courseId,
    courseSlug: payload.courseSlug,
    moduleId: payload.moduleId,
    userId: payload.userId,
    studentName: payload.studentName,
    studentEmail: payload.studentEmail,
    note: payload.note.trim(),
    fileUrl: payload.fileUrl,
    fileName: payload.fileName,
    status: payload.score != null ? 'graded' : 'submitted',
    ...(payload.score != null ? { score: payload.score } : {}),
    creator: payload.userId,
    createdAt: stamp,
    updatedAt: stamp,
  })) as AssignmentSubmission
}

export async function gradeSubmission(id: string, score: number, feedback: string) {
  if (typeof id !== 'string' || id === '[object Object]') {
    throw new Error('ID inválido')
  }
  return (await lumi.entities.assignment_submissions.update(id, {
    score,
    feedback: feedback.trim(),
    status: 'graded',
    updatedAt: nowIso(),
  })) as AssignmentSubmission
}

export function latestSubmissionFor(
  submissions: AssignmentSubmission[],
  assignmentId: string,
  userId: string,
) {
  return submissions.find((item) => item.assignmentId === assignmentId && item.userId === userId)
}
